import { useEffect, useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MAX_POLL_ATTEMPTS = 5;
const POLL_INTERVAL_MS = 2000;

export function usePaymentPoll(sessionId) {
  const [state, setState] = useState(sessionId ? "checking" : "error");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) return undefined;
    let cancelled = false;

    const poll = async () => {
      if (cancelled) return;
      if (attempts.current >= MAX_POLL_ATTEMPTS) {
        setState("timeout");
        return;
      }
      attempts.current += 1;
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (cancelled) return;
        if (res.data.payment_status === "paid") {
          setState("paid");
        } else if (res.data.status === "expired") {
          setState("expired");
        } else {
          setTimeout(poll, POLL_INTERVAL_MS);
        }
      } catch {
        if (!cancelled) setState("error");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return state;
}
